/**
 * Translation definitions and values
 */

// Interface for all translation keys
export interface AllTranslations {
  // Common actions
  'actions.login': string;
  'actions.logout': string;
  'actions.go_to_login': string;
  'actions.continue_as_guest': string;
  'actions.guest_accessing': string;
  'actions.try_again': string;
  'actions.add': string;
  'actions.edit': string;
  'actions.delete': string;
  'actions.save': string;
  'actions.cancel': string;
  'actions.search': string;
  'actions.filter': string;
  'actions.clear': string;
  'actions.create': string;
  'actions.update': string;
  'actions.manage': string;
  'actions.view': string;
  'actions.back': string;
  'actions.next': string;
  'actions.previous': string;
  'actions.refresh': string;
  'actions.save_changes': string;
  'actions.success': string;
  'actions.error': string;
  'actions.close': string;
  'actions.submit': string;
  'actions.reset': string;
  'actions.remove': string;
  'actions.user_updated': string;
  'actions.failed_to_update': string;
  'actions.failed_to_submit': string;
  'actions.manage_billing': string;
  'actions.loading': string;
  'actions.edit_club': string;
  'actions.archive': string;

  // Status types
  'status.active': string;
  'status.inactive': string;
  'status.archived': string;
  'status.suspended': string;
  'status.pending': string;
  'status.draft': string;
  'status.cancelled': string;
  'status.expired': string;

  // Loading and state messages
  'loading.default': string;
  'loading.dashboard': string;
  'loading.settings': string;
  'loading.spaces': string;

  // Common states
  'common.loading': string;
  'common.error': string;
  'common.success': string;

  // Error messages
  'errors.loading_data': string;
  'errors.unknown_error': string;
  'errors.something_went_wrong': string;
  'errors.unexpected_error_description': string;
  'errors.global_application_error': string;
  'errors.application_error': string;
  'errors.try_again': string;
  'errors.go_to_homepage': string;
  'errors.error_details_development': string;
  'errors.stack_trace': string;

  // User-related
  'user.unnamed': string;

  // Dashboard content
  'dashboard.title': string;
  'welcome': string;
  'dashboard.welcome_subtitle': string;
  'dashboard.my_bookings': string;
  'dashboard.next_booking': string;
  'dashboard.view_details': string;
  'dashboard.edit_booking': string;
  'dashboard.book_first_court': string;
  'dashboard.book_a_court': string;
  'dashboard.current_club': string;
  'dashboard.various_sports': string;
  'dashboard.courts_available': string;
  'dashboard.view_courts': string;
  'dashboard.no_club_selected': string;
  'dashboard.this_month': string;
  'dashboard.sessions': string;
  'dashboard.hours': string;
  'dashboard.playing_activity': string;
  'dashboard.track_court_time': string;
  'dashboard.peak_hours': string;
  'dashboard.at': string;
  'dashboard.no_upcoming_sessions': string;
  'dashboard.no_upcoming_bookings': string;
  'dashboard.no_upcoming_description': string;
  'dashboard.upcoming_sessions': string;
  'dashboard.upcoming_bookings': string;
  'dashboard.next_scheduled_times': string;
  'dashboard.view_all_bookings': string;
  'dashboard.new_booking': string;
  'dashboard.club_default': string;
  'dashboard.recent_payments': string;
  'dashboard.no_recent_payments': string;
  'dashboard.latest_transaction_history': string;
  
  // Dashboard KPI Cards
  'dashboard.upcoming_sessions_title': string;
  'dashboard.peak_hours_usage': string;
  'dashboard.most_popular_booking_time': string;
  'dashboard.hours_played': string;
  'dashboard.total_hours_booking_history': string;
  'dashboard.membership_status': string;
  'dashboard.active_membership': string;
  'dashboard.session': string;
  'dashboard.scheduled': string;
  
  // Dashboard additional keys
  'dashboard.player_stats': string;
  'dashboard.total_hours': string;
  'dashboard.membership': string;
  'dashboard.quick_actions': string;
  'dashboard.view_bookings': string;
  'dashboard.update_profile': string;
  'dashboard.book_now': string;
  'dashboard.upcoming': string;
  'dashboard.player': string;
  'dashboard.players': string;

  // Organizations
  'organization.manage_title': string;
  'organization.manage_description': string;
  'organization.create': string;
  'organization.create_title': string;
  'organization.create_description': string;
  'organization.edit': string;
  'organization.name': string;
  'organization.email': string;
  'organization.phone': string;
  'organization.address': string;
  'organization.status': string;
  'organization.date_created': string;
  'organization.actions': string;
  'organization.no_organizations_found': string;
  'organization.showing_results': string;
  'organization.overview_title': string;
  'organization.overview_description': string;

  // Organization Plans
  'organization.plans.available_plans': string;
  'organization.plans.current_plan': string;
  'organization.plans.current_label': string;
  'organization.plans.active_since': string;
  'organization.plans.billing_info_label': string;
  'organization.plans.billing_info_description': string;
  'organization.plans.users': string;
  'organization.plans.features_included': string;
  'organization.plans.no_features_listed': string;
  'organization.plans.upgrade_to': string;

  // Bookings
  'bookings.new_booking': string;
  'bookings.new_booking_description': string;
  'bookings.edit_booking': string;
  'bookings.edit_booking_description': string;
  'bookings.booking_details': string;
  'bookings.view_booking_information': string;
  'bookings.details': string;
  'bookings.basic_information': string;
  'bookings.location_payment': string;
  'bookings.cancel_booking': string;
  'bookings.book_another': string;
  'bookings.booking_id': string;
  'bookings.status': string;
  'bookings.sport': string;
  'bookings.repeat': string;
  'bookings.notes': string;
  'bookings.space': string;
  'bookings.price': string;
  'bookings.payment_status': string;
  'bookings.person': string;
  'bookings.people': string;
  'bookings.back_to_calendar': string;
  'bookings.back_to_bookings': string;

  // Navigation - Main
  'navigation.dashboard': string;
  'navigation.calendar': string;
  'navigation.bookings': string;
  'navigation.help': string;
  'navigation.admin': string;
  'navigation.account': string;
  'navigation.super_admin': string;

  // Navigation - Admin Section
  'navigation.admin.organization': string;
  'navigation.admin.clubs': string;
  'navigation.admin.subscriptions': string;
  'navigation.admin.spaces': string;
  'navigation.admin.staff': string;
  'navigation.admin.users': string;
  'navigation.admin.analytics': string;
  'navigation.admin.settings': string;

  // Navigation - Account Section
  'navigation.account.profile': string;
  'navigation.account.password': string;
  'navigation.account.billing': string;
  'navigation.account.settings': string;

  // Navigation - Super Admin Section
  'navigation.super_admin.platform_dashboard': string;
  'navigation.super_admin.organizations': string;
  'navigation.super_admin.manage_organizations': string;
  'navigation.super_admin.add_organization': string;
  'navigation.super_admin.platform_management': string;
  'navigation.super_admin.manage_plans': string;
  'navigation.super_admin.manage_features': string;
  'navigation.super_admin.platform_insights': string;
  'navigation.super_admin.system': string;
  'navigation.super_admin.platform_settings': string;
  'navigation.super_admin.security_audit': string;
  'navigation.super_admin.secret_manager': string;
  'navigation.super_admin.firebase_tools': string;
  'navigation.super_admin.impersonation': string;

  // Pages - Main
  'pages.bookings': string;
  'pages.calendar': string;
  'pages.help': string;

  // Pages - Account Section
  'pages.account.profile': string;
  'pages.account.password': string;
  'pages.account.billing': string;
  'pages.account.settings': string;

  // Account - Profile Settings
  'account.profile_settings': string;

  // Account - Password & Security
  'account.fill_all_fields': string;
  'account.missing_fields': string;

  // Account - Billing
  'account.payment_method_removed': string;
  'account.failed_remove_payment': string;
  'account.could_not_remove_payment': string;

  // Account Settings
  'account.settings.display': string;
  'account.settings.display_description': string;
  'account.settings.default_view_label': string;
  'account.settings.default_view_description': string;
  'account.settings.appearance': string;
  'account.settings.appearance_description': string;
  'account.settings.language_label': string;
  'account.settings.language_description': string;
  'account.notifications': string;
  'account.manage_notifications_description': string;

  // Pages - Admin Section
  'pages.admin.dashboard': string;
  'pages.admin.analytics': string;
  'pages.admin.organization': string;
  'pages.admin.clubs': string;
  'pages.admin.subscriptions': string;
  'pages.admin.spaces': string;
  'pages.admin.staff': string;
  'pages.admin.users': string;
  'pages.admin.settings': string;
  'pages.admin.manage_organizations': string;
  'pages.admin.roles': string;
  'pages.admin.organization.plans': string;

  // Pages - Super Admin Section
  'pages.super_admin.dashboard': string;
  'pages.super_admin.analytics': string;
  'pages.super_admin.settings': string;
  'pages.super_admin.plans': string;
  'pages.super_admin.roles': string;
  'pages.super_admin.organization_impersonation': string;
  'pages.super_admin.manage_organizations': string;
  'pages.super_admin.manage_plans': string;
  'pages.super_admin.manage_features': string;
  'pages.super_admin.insights_organizations': string;
  'pages.super_admin.configurations': string;
  'pages.super_admin.security': string;
  'pages.super_admin.secret_manager': string;
  'pages.super_admin.firebase_tools': string;
  'pages.super_admin.feature_flags': string;
  'pages.super_admin.plan_limits': string;

  // Admin Settings
  'admin.settings.general_settings_title': string;
  'admin.settings.general_settings_desc': string;
  'admin.settings.domain_title': string;
  'admin.settings.custom_domain_label': string;
  'admin.settings.custom_domain_desc': string;
  'admin.settings.fetch_failed': string;
  'admin.settings.currencies_fetch_failed': string;
  'admin.settings.supporting_data_load_failed': string;
  'admin.settings.update_failed': string;
  'admin.settings.time_date_settings_title': string;
  'admin.settings.time_date_settings_desc': string;
  'admin.settings.timezone_label': string;
  'admin.settings.timezone_desc': string;
  'admin.settings.select_timezone': string;
  'admin.settings.payment_settings_title': string;
  'admin.settings.payment_settings_desc': string;
  'admin.settings.role_specific_settings_title': string;
  'admin.settings.role_specific_settings_desc': string;
  'admin.settings.role_settings_title': string;
  'admin.settings.autosave_slider_success': string;
  'admin.settings.slider_hours_format': string;
  'admin.settings.slider_days_format': string;

  // Admin Settings - Roles
  'admin.settings.roles.future_booking_limit': string;
  'admin.settings.roles.future_booking_limit_desc': string;
  'admin.settings.roles.max_hours_per_day': string;
  'admin.settings.roles.max_hours_per_day_desc': string;
  'admin.settings.roles.calendar_visibility_days': string;
  'admin.settings.roles.calendar_visibility_days_desc': string;
  'admin.settings.roles.cancellation_window_hours': string;
  'admin.settings.roles.cancellation_window_hours_desc': string;

  // Roles
  'roles.guest': string;
  'roles.member': string;
  'roles.teacher': string;
  'roles.tennisSchool': string;
  'roles.tennisClub': string;

  // Common
  'common.coming_soon': string;
  'common.no_limit': string;

  // Tabs
  'tabs.general': string;
  'tabs.time_and_date': string;
  'tabs.role_settings': string;
  'tabs.payment': string;

  // Descriptions
  'descriptions.admin.settings': string;
  'descriptions.admin.staff': string;
  'descriptions.admin.spaces': string;
  'descriptions.admin.clubs': string;
  'descriptions.admin.organization.plans': string;
  'descriptions.super_admin.dashboard': string;
  'descriptions.super_admin.settings': string;
  'descriptions.super_admin.roles': string;
  'descriptions.help': string;

  // Analytics
  'analytics.charts_title': string;
  'analytics.charts_description': string;

  // Errors
  'errors.loading_analytics': string;
  'error.organization_load': string;

  // Buttons
  'buttons.add_new_staff': string;
  'buttons.add_new_space': string;
  'buttons.add_new_club': string;

  // Stats
  'stats.total_staff': string;
  'stats.active_staff': string;
  'stats.all_staff_members': string;
  'stats.currently_active': string;
  'stats.total_spaces': string;
  'stats.active_spaces': string;
  'stats.all_spaces': string;
  'stats.total_clubs': string;
  'stats.active_clubs': string;
  'stats.all_clubs_in_organization': string;

  // Tables
  'tables.staff.title': string;
  'tables.spaces.title': string;
  'tables.clubs.title': string;

  // Pagination
  'pagination.showing': string;
  'pagination.to': string;
  'pagination.of': string;
  'pagination.results': string;
  'pagination.page': string;
  'pagination.previous': string;
  'pagination.next': string;

  // Not Found Page
  'not_found.title': string;
  'not_found.description': string;
  'not_found.go_to_homepage': string;
  'not_found.go_back': string;
  'not_found.dashboard': string;
  'not_found.help_text': string;
  'not_found.help_center': string;
  'not_found.contact_support': string;

  // Messages
  'messages.loading_dashboard': string;

  // Placeholders
  'placeholder.select_language': string;

  // Data
  'data.not_available': string;

  // Empty states
  'empty.clubs': string;

  // Plans
  'plans.unable_to_load': string;
}

// Consolidated translations - English
export const translations: Record<keyof AllTranslations, string> = {
  // Common actions
  'actions.login': 'Log in',
  'actions.logout': 'Log out',
  'actions.go_to_login': 'Go to login',
  'actions.continue_as_guest': 'Continue as Guest',
  'actions.guest_accessing': 'Accessing...',
  'actions.try_again': 'Try again',
  'actions.add': 'Add',
  'actions.edit': 'Edit',
  'actions.delete': 'Delete',
  'actions.save': 'Save',
  'actions.cancel': 'Cancel',
  'actions.search': 'Search',
  'actions.filter': 'Filter',
  'actions.clear': 'Clear',
  'actions.create': 'Create',
  'actions.update': 'Update',
  'actions.manage': 'Manage',
  'actions.view': 'View',
  'actions.back': 'Back',
  'actions.next': 'Next',
  'actions.previous': 'Previous',
  'actions.refresh': 'Refresh',
  'actions.save_changes': 'Save Changes',
  'actions.success': 'Success',
  'actions.error': 'Error',
  'actions.close': 'Close',
  'actions.submit': 'Submit',
  'actions.reset': 'Reset',
  'actions.remove': 'Remove',
  'actions.user_updated': 'User updated successfully',
  'actions.failed_to_update': 'Failed to update user',
  'actions.failed_to_submit': 'Failed to submit form',
  'actions.manage_billing': 'Manage Billing',
  'actions.loading': 'Loading',
  'actions.edit_club': 'Edit Club',
  'actions.archive': 'Archive',

  // Status types
  'status.active': 'Active',
  'status.inactive': 'Inactive',
  'status.archived': 'Archived',
  'status.suspended': 'Suspended',
  'status.pending': 'Pending',
  'status.draft': 'Draft',
  'status.cancelled': 'Cancelled',
  'status.expired': 'Expired',

  // Loading and state messages
  'loading.default': 'please wait...',
  'loading.dashboard': 'Loading Dashboard...',
  'loading.settings': 'Loading Settings...',
  'loading.spaces': 'Loading Spaces...',

  // Common states
  'common.loading': 'Loading...',
  'common.error': 'An Error Occurred',
  'common.success': 'Success',

  // Error messages
  'errors.loading_data': 'Error loading data',
  'errors.unknown_error': 'Unknown error occurred',
  'errors.something_went_wrong': 'Something went wrong!',
  'errors.unexpected_error_description': 'We apologize for the inconvenience. An unexpected error has occurred.',
  'errors.global_application_error': 'Global application error',
  'errors.application_error': 'Application error',
  'errors.try_again': 'Try again',
  'errors.go_to_homepage': 'Go to Homepage',
  'errors.error_details_development': 'Error Details (Development)',
  'errors.stack_trace': 'Stack trace',

  // User-related
  'user.unnamed': 'Unnamed',

  // Dashboard content
  'dashboard.title': 'Dashboard',
  'welcome': 'Welcome',
  'dashboard.welcome_subtitle': 'Ready to play? Book your next court or check your stats.',
  'dashboard.my_bookings': 'My Bookings',
  'dashboard.next_booking': 'Next Booking',
  'dashboard.view_details': 'View Details',
  'dashboard.edit_booking': 'Edit Booking',
  'dashboard.book_first_court': 'Book Your First Court',
  'dashboard.book_a_court': 'Book a Court',
  'dashboard.current_club': 'Current Club',
  'dashboard.various_sports': 'Tennis, Padel, Foot5',
  'dashboard.courts_available': 'courts available',
  'dashboard.view_courts': 'View Courts',
  'dashboard.no_club_selected': 'No club selected',
  'dashboard.this_month': 'This Month',
  'dashboard.sessions': 'sessions',
  'dashboard.hours': 'Hours',
  'dashboard.playing_activity': 'Your Playing Activity',
  'dashboard.track_court_time': 'Track your court time over the months',
  'dashboard.peak_hours': 'Peak Hours',
  'dashboard.at': 'at',
  'dashboard.no_upcoming_sessions': 'No upcoming sessions',
  'dashboard.no_upcoming_bookings': 'No upcoming bookings',
  'dashboard.no_upcoming_description': 'Book your first court session to get started',
  'dashboard.upcoming_sessions': 'Upcoming Sessions',
  'dashboard.upcoming_bookings': 'Upcoming Bookings',
  'dashboard.next_scheduled_times': 'Next Scheduled Times',
  'dashboard.view_all_bookings': 'View All Bookings',
  'dashboard.new_booking': 'New Booking',
  'dashboard.club_default': 'Club',
  'dashboard.recent_payments': 'Recent Payments',
  'dashboard.no_recent_payments': 'No recent payments found',
  'dashboard.latest_transaction_history': 'Your latest transaction history',
  
  // Dashboard KPI Cards
  'dashboard.upcoming_sessions_title': 'Upcoming Sessions',
  'dashboard.peak_hours_usage': 'Peak Hours Usage',
  'dashboard.most_popular_booking_time': 'Most popular booking time today',
  'dashboard.hours_played': 'Hours Played',
  'dashboard.total_hours_booking_history': 'Total hours based on booking history',
  'dashboard.membership_status': 'Membership Status',
  'dashboard.active_membership': 'Active membership',
  'dashboard.session': 'session',
  'dashboard.scheduled': 'scheduled',
  
  // Dashboard additional keys
  'dashboard.player_stats': 'Player Stats',
  'dashboard.total_hours': 'Total Hours',
  'dashboard.membership': 'Membership',
  'dashboard.quick_actions': 'Quick Actions',
  'dashboard.view_bookings': 'View Bookings',
  'dashboard.update_profile': 'Update Profile',
  'dashboard.book_now': 'Book Now',
  'dashboard.upcoming': 'Upcoming',
  'dashboard.player': 'player',
  'dashboard.players': 'players',

  // Organizations
  'organization.manage_title': 'Manage Organizations',
  'organization.manage_description': 'View and manage all organizations on the platform',
  'organization.create': 'Create Organization',
  'organization.create_title': 'Create Organization',
  'organization.create_description': 'Create a new organization on the platform',
  'organization.edit': 'Edit Organization',
  'organization.name': 'Name',
  'organization.email': 'Email',
  'organization.phone': 'Phone',
  'organization.address': 'Address',
  'organization.status': 'Status',
  'organization.date_created': 'Date Created',
  'organization.actions': 'Actions',
  'organization.no_organizations_found': 'No organizations found',
  'organization.showing_results': 'Showing organizations',
  'organization.overview_title': 'Organization Overview',
  'organization.overview_description': 'View and manage your organization details',

  // Organization Plans
  'organization.plans.available_plans': 'Available Plans',
  'organization.plans.current_plan': 'Current Plan',
  'organization.plans.current_label': 'Current',
  'organization.plans.active_since': 'Active Since',
  'organization.plans.billing_info_label': 'Billing Info',
  'organization.plans.billing_info_description': 'Manage your billing information and payment methods',
  'organization.plans.users': 'Users',
  'organization.plans.features_included': 'Features Included',
  'organization.plans.no_features_listed': 'No features listed for this plan',
  'organization.plans.upgrade_to': 'Upgrade to',

  // Bookings
  'bookings.new_booking': 'New Booking',
  'bookings.new_booking_description': 'Description for new booking',
  'bookings.edit_booking': 'Edit Booking',
  'bookings.edit_booking_description': 'Description for editing a booking',
  'bookings.booking_details': 'Booking Details',
  'bookings.view_booking_information': 'View and manage your booking information',
  'bookings.details': 'Booking Details',
  'bookings.basic_information': 'Basic Information',
  'bookings.location_payment': 'Location & Payment',
  'bookings.cancel_booking': 'Cancel Booking',
  'bookings.book_another': 'Book Another',
  'bookings.booking_id': 'Booking ID',
  'bookings.status': 'Status',
  'bookings.sport': 'Sport',
  'bookings.repeat': 'Repeat',
  'bookings.notes': 'Notes',
  'bookings.space': 'Space',
  'bookings.price': 'Price',
  'bookings.payment_status': 'Payment Status',
  'bookings.person': 'Person',
  'bookings.people': 'People',
  'bookings.back_to_calendar': 'Back to Calendar',
  'bookings.back_to_bookings': 'Back to Bookings',

  // Navigation - Main
  'navigation.dashboard': 'Dashboard',
  'navigation.calendar': 'Calendar',
  'navigation.bookings': 'Bookings',
  'navigation.help': 'Help',
  'navigation.admin': 'Admin',
  'navigation.account': 'Account',
  'navigation.super_admin': 'Super Admin',

  // Navigation - Admin Section
  'navigation.admin.organization': 'Organization',
  'navigation.admin.clubs': 'Clubs',
  'navigation.admin.subscriptions': 'Subscriptions',
  'navigation.admin.spaces': 'Spaces',
  'navigation.admin.staff': 'Staff',
  'navigation.admin.users': 'Users',
  'navigation.admin.analytics': 'Analytics',
  'navigation.admin.settings': 'Settings',

  // Navigation - Account Section
  'navigation.account.profile': 'Profile',
  'navigation.account.password': 'Password',
  'navigation.account.billing': 'Billing',
  'navigation.account.settings': 'Settings',

  // Navigation - Super Admin Section
  'navigation.super_admin.platform_dashboard': 'Platform Dashboard',
  'navigation.super_admin.organizations': 'Organizations',
  'navigation.super_admin.manage_organizations': 'Manage Organizations',
  'navigation.super_admin.add_organization': 'Add Organization',
  'navigation.super_admin.platform_management': 'Platform Management',
  'navigation.super_admin.manage_plans': 'Manage Plans',
  'navigation.super_admin.manage_features': 'Manage Features',
  'navigation.super_admin.platform_insights': 'Platform Insights',
  'navigation.super_admin.system': 'System',
  'navigation.super_admin.platform_settings': 'Platform Settings',
  'navigation.super_admin.security_audit': 'Security Audit',
  'navigation.super_admin.secret_manager': 'Secret Manager',
  'navigation.super_admin.firebase_tools': 'Firebase Tools',
  'navigation.super_admin.impersonation': 'Impersonation',

  // Pages - Main
  'pages.bookings': 'Bookings',
  'pages.calendar': 'Calendar',
  'pages.help': 'Help',

  // Pages - Account Section
  'pages.account.profile': 'Profile',
  'pages.account.password': 'Password',
  'pages.account.billing': 'Billing',
  'pages.account.settings': 'Settings',

  // Account - Profile Settings
  'account.profile_settings': 'Profile Settings',

  // Account - Password & Security
  'account.fill_all_fields': 'Fill all fields',
  'account.missing_fields': 'Missing fields',

  // Account - Billing
  'account.payment_method_removed': 'Payment method removed',
  'account.failed_remove_payment': 'Failed to remove payment',
  'account.could_not_remove_payment': 'Could not remove payment',

  // Account Settings
  'account.settings.display': 'Display Settings',
  'account.settings.display_description': 'Configure how information is displayed',
  'account.settings.default_view_label': 'Default View',
  'account.settings.default_view_description': 'Choose your preferred default calendar view',
  'account.settings.appearance': 'Appearance',
  'account.settings.appearance_description': 'Customize the look and feel of your account',
  'account.settings.language_label': 'Language',
  'account.settings.language_description': 'Select your preferred language',
  'account.notifications': 'Notifications',
  'account.manage_notifications_description': 'Configure your notification preferences',

  // Pages - Admin Section
  'pages.admin.dashboard': 'Dashboard',
  'pages.admin.analytics': 'Analytics',
  'pages.admin.organization': 'Organization',
  'pages.admin.clubs': 'Clubs',
  'pages.admin.subscriptions': 'Subscriptions',
  'pages.admin.spaces': 'Spaces',
  'pages.admin.staff': 'Staff',
  'pages.admin.users': 'Users',
  'pages.admin.settings': 'Settings',
  'pages.admin.manage_organizations': 'Manage Organizations',
  'pages.admin.roles': 'Roles',
  'pages.admin.organization.plans': 'Organization Plans',

  // Pages - Super Admin Section
  'pages.super_admin.dashboard': 'Platform Dashboard',
  'pages.super_admin.analytics': 'Analytics',
  'pages.super_admin.settings': 'Settings',
  'pages.super_admin.plans': 'Plans',
  'pages.super_admin.roles': 'Roles',
  'pages.super_admin.organization_impersonation': 'Organization Impersonation',
  'pages.super_admin.manage_organizations': 'Manage Organizations',
  'pages.super_admin.manage_plans': 'Manage Plans',
  'pages.super_admin.manage_features': 'Manage Features',
  'pages.super_admin.insights_organizations': 'Insights Organizations',
  'pages.super_admin.configurations': 'Configurations',
  'pages.super_admin.security': 'Security',
  'pages.super_admin.secret_manager': 'Secret Manager',
  'pages.super_admin.firebase_tools': 'Firebase Tools',
  'pages.super_admin.feature_flags': 'Feature Flags',
  'pages.super_admin.plan_limits': 'Plan Limits',

  // Admin Settings
  'admin.settings.general_settings_title': 'General Settings',
  'admin.settings.general_settings_desc': 'Configure general settings for your platform',
  'admin.settings.domain_title': 'Domain',
  'admin.settings.custom_domain_label': 'Custom Domain',
  'admin.settings.custom_domain_desc': 'Enter your custom domain',
  'admin.settings.fetch_failed': 'Failed to fetch data',
  'admin.settings.currencies_fetch_failed': 'Failed to fetch currencies',
  'admin.settings.supporting_data_load_failed': 'Failed to load supporting data',
  'admin.settings.update_failed': 'Failed to update',
  'admin.settings.time_date_settings_title': 'Time & Date Settings',
  'admin.settings.time_date_settings_desc': 'Configure time and date settings',
  'admin.settings.timezone_label': 'Organization Timezone',
  'admin.settings.timezone_desc': 'Set the default timezone for your organization',
  'admin.settings.select_timezone': 'Select timezone',
  'admin.settings.payment_settings_title': 'Payment Settings',
  'admin.settings.payment_settings_desc': 'Configure payment settings',
  'admin.settings.role_specific_settings_title': 'Role-Specific Settings',
  'admin.settings.role_specific_settings_desc': 'Configure settings specific to your role',
  'admin.settings.role_settings_title': 'Role Settings',
  'admin.settings.autosave_slider_success': 'Setting saved successfully',
  'admin.settings.slider_hours_format': 'hours',
  'admin.settings.slider_days_format': 'days',

  // Admin Settings - Roles
  'admin.settings.roles.future_booking_limit': 'Future Booking Limit',
  'admin.settings.roles.future_booking_limit_desc': 'Maximum number of bookings allowed in the future',
  'admin.settings.roles.max_hours_per_day': 'Max Hours per Day',
  'admin.settings.roles.max_hours_per_day_desc': 'Maximum hours allowed per day',
  'admin.settings.roles.calendar_visibility_days': 'Calendar Visibility Days',
  'admin.settings.roles.calendar_visibility_days_desc': 'Days to show in the calendar',
  'admin.settings.roles.cancellation_window_hours': 'Cancellation Window Hours',
  'admin.settings.roles.cancellation_window_hours_desc': 'Hours before booking can be cancelled',

  // Roles
  'roles.guest': 'Guest',
  'roles.member': 'Member',
  'roles.teacher': 'Teacher',
  'roles.tennisSchool': 'Tennis School',
  'roles.tennisClub': 'Tennis Club',

  // Common
  'common.coming_soon': 'Coming Soon',
  'common.no_limit': 'No Limit',

  // Tabs
  'tabs.general': 'General',
  'tabs.time_and_date': 'Time & Date',
  'tabs.role_settings': 'Role Settings',
  'tabs.payment': 'Payment',

  // Descriptions
  'descriptions.admin.settings': 'Configure platform settings',
  'descriptions.admin.staff': 'Manage staff members',
  'descriptions.admin.spaces': 'Manage spaces and courts',
  'descriptions.admin.clubs': 'Manage clubs and facilities',
  'descriptions.admin.organization.plans': 'Manage organization subscription plans and billing',
  'descriptions.super_admin.dashboard': 'Manage platform-wide settings, organizations, and system configurations',
  'descriptions.super_admin.settings': 'Configure platform-wide settings and system preferences',
  'descriptions.super_admin.roles': 'Manage platform roles and permissions',
  'descriptions.help': 'Find answers to common questions and learn how to use the platform effectively',

  // Analytics
  'analytics.charts_title': 'Analytics Charts',
  'analytics.charts_description': 'Comprehensive analytics and insights',

  // Errors
  'errors.loading_analytics': 'Failed to load analytics data',
  'error.organization_load': 'Failed to load organization data',

  // Buttons
  'buttons.add_new_staff': 'Add New Staff',
  'buttons.add_new_space': 'Add New Space',
  'buttons.add_new_club': 'Add New Club',

  // Stats
  'stats.total_staff': 'Total Staff',
  'stats.active_staff': 'Active Staff',
  'stats.all_staff_members': 'All Staff Members',
  'stats.currently_active': 'Currently Active',
  'stats.total_spaces': 'Total Spaces',
  'stats.active_spaces': 'Active Spaces',
  'stats.all_spaces': 'All Spaces',
  'stats.total_clubs': 'Total Clubs',
  'stats.active_clubs': 'Active Clubs',
  'stats.all_clubs_in_organization': 'All Clubs in Organization',

  // Tables
  'tables.staff.title': 'Staff Members',
  'tables.spaces.title': 'Spaces',
  'tables.clubs.title': 'Clubs',

  // Pagination
  'pagination.showing': 'Showing',
  'pagination.to': 'to',
  'pagination.of': 'of',
  'pagination.results': 'results',
  'pagination.page': 'Page',
  'pagination.previous': 'Previous',
  'pagination.next': 'Next',

  // Not Found Page
  'not_found.title': 'Page Not Found',
  'not_found.description': 'Sorry, we couldn\'t find the page you\'re looking for. It might have been moved, deleted, or you entered the wrong URL.',
  'not_found.go_to_homepage': 'Go to Homepage',
  'not_found.go_back': 'Go Back',
  'not_found.dashboard': 'Dashboard',
  'not_found.help_text': 'Need help? Contact our support team or check our',
  'not_found.help_center': 'help center',
  'not_found.contact_support': 'Contact Support',

  // Messages
  'messages.loading_dashboard': 'Loading Dashboard...',

  // Placeholders
  'placeholder.select_language': 'Select a language',

  // Data
  'data.not_available': 'N/A',

  // Empty states
  'empty.clubs': 'No clubs found',

  // Plans
  'plans.unable_to_load': 'Unable to load plans',
}; 